﻿import React from 'react';
import IconHelper from '@bazooka_se/lf-icons';

const Achievements = (props) => {

    const [stars, setStars] = React.useState([]);

    React.useEffect(() => {

        if (props.data) {
            setStars(props.data.map((star, index) => {
                return star;
            }))
        }
    }, [props.data])

    return (
        <div>

            {stars.length > 0 &&
                stars.sort((a, b) => b.isAchieved - a.isAchieved)
                .map((star, index) => {
                  
                return (
                <li className="my-pages-achievements__list__item" key={index}>
                    {star.isAchieved === true
                        ?
                        <img className="my-pages-achievements__list__item__star" src="/images/star-checked.svg" />
                        :
                        <img className="my-pages-achievements__list__item__star"  src="/images/star-unchecked.svg" />
                    }
                    <div className="my-pages-achievements__list__item__text__container" >
                        <p className="my-pages-achievements__list__item__text__container__description">{star.description.description}</p>

                        {star.isAchieved === false &&
                            <a className="my-pages-achievements__list__item__text__link arrow-link" href={star.description.actionLinkUrl}>
                                {star.description.actionLinkText} <span className="icon" dangerouslySetInnerHTML={{ __html: IconHelper('long-arrow-right').outerHTML }}></span>
                            </a>
                        }
                    </div>
                 </li>                 
                )
            })}
        </div>
     )
 }                

export default Achievements;


